module.exports = __webpack_public_path__ + "static/cortex-web-home-banner-min-df4d3cb9fae07caef857609eaa7e2a85.jpg";